<script setup lang="ts">
import { tpgIconCheck, tpgIconError } from '@tpg/grammar-web-icons';
import { toTypedSchema } from '@vee-validate/yup';
import { useField } from 'vee-validate';
import { useI18n } from 'vue-i18n';

import { GrammarTextField } from '@nora-monorepo/grammar-ui';
import { DRAW_LAYER_NAME_MAX_LENGTH } from '@nora-monorepo/shared';

import { createDrawLayerNameSchema } from '#ui-shared/validation/draw-layer-name.schema';

interface DrawLayerNameInputProps {
  /**
   * Represents the vee-validate field path for the draw layer name.
   */
  name: string;
}

const props = defineProps<DrawLayerNameInputProps>();
const { t } = useI18n();

const { value, errorMessage, meta } = useField<string>(() => props.name, toTypedSchema(createDrawLayerNameSchema(t)));
</script>

<template>
  <GrammarTextField
    :value="value"
    :label="t('drawLayer.drawLayerNameLabel')"
    :trailing-icon-template="meta.valid ? tpgIconCheck : tpgIconError"
    :form-associated="true"
    :counter="DRAW_LAYER_NAME_MAX_LENGTH"
    :type="meta.valid ? 'default' : 'error'"
    :message="errorMessage"
    @change="value = $event"
    @input="value = $event"
  />
</template>
